import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-dlh-greenPale text-center px-4">
      <Leaf className="h-16 w-16 text-dlh-greenLight mb-4" />
      <h1 className="font-serif text-6xl font-extrabold text-dlh-green">404</h1>
      <p className="mt-2 text-gray-600">Halaman yang Anda cari tidak ditemukan.</p>
      <Link to="/" className="mt-6 inline-block bg-dlh-green text-white px-6 py-3 rounded-full font-semibold hover:bg-dlh-greenDark">Kembali ke Beranda</Link>
    </div>
  );
}
